import Dialog from 'material-ui/Dialog'
import intl from 'react-intl-universal'
import 'components/delete-dialog/delete-dialog.css'
import PropTypes from 'prop-types'
import Button from 'components/button';

export const ModalAlert = ({ open, handleClose, handleConfirm, title, message }) => (
  <Dialog
    title={<div data-testid='warning-create-lc'>{intl.get("modalLcAlert.warning")}</div>}
    contentStyle={{ width: '560px' }}
    open={open}
    onRequestClose={handleClose}
    actionsContainerClassName="container-action-buttons__deleteModal"
    actions={
      [
        <Button
          value={intl.get('master-data.general.materials.cancel')}
          id="btn-cancel-modal-alert-transit-time-lc"
          buttonType='default'
          onClick={handleClose}
          className='container-action-buttons__deleteModal--buttons'
          key={1}
        />,
        <Button
          value={intl.get('modalLcAlert.confirm')}
          id="btn-confirm-modal-alert-transit-time-lc"
          buttonType='danger'
          onClick={handleConfirm}
          className='container-action-buttons__deleteModal--buttons'
          key={2}
        />
      ]
    } >
    <div className='container-message'>
      <p>{title || intl.get("modalLcAlert.message01")}</p>
      <p>{message || intl.get("modalLcAlert.message02")}</p>
    </div>
  </Dialog>
);

ModalAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string
};
